import React from "react";

import GuestContributorsContainer from "../../modules/GuestContributors/containers/GuestContributorsContainer/GuestContributorsContainer";

const GuestContributors = () => {
  return <GuestContributorsContainer />;
};

export default GuestContributors;

